import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import VerifiedIcon from '@mui/icons-material/Verified';
import './Services.style.css';

const BASE = process.env.REACT_APP_API_BASE_URL;

const Stars = ({ rating = 0 }) => (
  <div className="srv-stars">
    {[1, 2, 3, 4, 5].map(s => (
      <span key={s} className={s <= Math.round(rating) ? "srv-star filled" : "srv-star"}>★</span>
    ))}
  </div>
);

const SellerCard = ({ seller, t }) => {
  const coverUrl = seller.coverImage
    ? `${BASE}/cover-images/${seller.coverImage}`
    : "/default-cover.svg";

  const avatarUrl = seller.profileImage
    ? `${BASE}/profile-images/${seller.profileImage}`
    : `https://ui-avatars.com/api/?name=${encodeURIComponent(seller.fullName || "Pro")}&background=5F41E4&color=fff&size=120&bold=true&format=png`;

  const desc = seller.description || seller.bio || "";
  const rating = seller.averageRating ?? seller.rating ?? 0;

  return (
    <Link to={`/profile/${seller.id}`} className="srv-card-link">
      <div className="srv-card">

        {/* Cover */}
        <div className="srv-card__cover">
          <img
            src={coverUrl}
            alt="cover"
            onError={e => { e.target.src = "/default-cover.svg"; }}
          />
        </div>

        {/* Avatar */}
        <div className="srv-card__avatar-wrap">
          <img
            className="srv-card__avatar"
            src={avatarUrl}
            alt={seller.fullName}
            onError={e => {
              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(seller.fullName || "Pro")}&background=5F41E4&color=fff&size=120&bold=true&format=png`;
            }}
          />
        </div>

        {/* Body */}
        <div className="srv-card__body">
          <div className="srv-card__name-row">
            <h3 className="srv-card__name">{seller.fullName}</h3>
            <VerifiedIcon className="srv-card__verified" fontSize="small" />
          </div>

          {seller.address && (
            <p className="srv-card__addr">
              <LocationOnIcon sx={{ fontSize: 13 }} /> {seller.address}
            </p>
          )}

          {rating > 0 && <Stars rating={rating} />}

          <hr className="srv-card__divider" />

          {desc && (
            <p className="srv-card__desc">
              {desc.length > 90 ? desc.slice(0, 90) + "…" : desc}
            </p>
          )}

          {seller.carCount > 0 && (
            <div className="srv-card__count">
              <DirectionsCarIcon sx={{ fontSize: 14 }} />
              {seller.carCount} {t("carsListed")}
            </div>
          )}

          <span className="srv-card__cta">{t("seeProfile")} →</span>
        </div>
      </div>
    </Link>
  );
};

export const Services = () => {
  const { t } = useTranslation();
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${BASE}/api/account/professionals`)
      .then(r => setSellers(Array.isArray(r.data) ? r.data : []))
      .catch(() => setSellers([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading || sellers.length === 0) return null;

  return (
    <section id="service" className="srv-section">
      <div className="srv-container">

        <div className="srv-header">
          <div className="srv-header__left">
            <span className="srv-header__label">{t("verifiedPartners")}</span>
            <h2>{t("professionalSellers")}</h2>
          </div>
          <Link to="/featured-cars" className="srv-header__cta">
            Voir toutes les annonces →
          </Link>
        </div>

        <div className="srv-grid">
          {sellers.map(seller => (
            <SellerCard key={seller.id} seller={seller} t={t} />
          ))}
        </div>

      </div>
    </section>
  );
};
